module.exports = __webpack_public_path__ + "static/w-nia-1e0be1d6f8769210dc9533e15659f5b8.jpg";